module.exports = {
	"default": {}
}